var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex justify-content-start align-items-center" },
    [
      _c(
        "div",
        { staticClass: "pl-2" },
        [
          _c("img", {
            attrs: {
              id: "badge-verified",
              src: "/static/img/badge-security.svg",
              alt: "",
              width: "24"
            }
          }),
          _vm._v(" "),
          _c("b-popover", {
            attrs: {
              target: "badge-verified",
              placement: "bottom",
              triggers: "hover",
              title: _vm.$t(
                "message.professional.verified_background_check_title"
              ),
              content: _vm.$t(
                "message.professional.verified_background_check_detail"
              )
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.professional.has_vacuum_cleaner
        ? _c(
            "div",
            { staticClass: "pl-2" },
            [
              _c("img", {
                attrs: {
                  id: "badge-vacuum-cleaner",
                  src: "/static/img/badge-vacuum-cleaner.svg",
                  alt: "",
                  width: "24"
                }
              }),
              _vm._v(" "),
              _c("b-popover", {
                attrs: {
                  target: "badge-vacuum-cleaner",
                  placement: "bottom",
                  triggers: "hover",
                  title: _vm.$t("message.professional.has_vacuum_cleaner"),
                  content: _vm.$t(
                    "message.professional.has_vacuum_cleaner_detail"
                  )
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.professional.professional_pet_types.length > 0
        ? _c(
            "div",
            { staticClass: "pl-2" },
            [
              _c("img", {
                attrs: {
                  id: "badge-inconvenient-pet",
                  src: "/static/img/badge-inconvenient-pet.svg",
                  alt: "",
                  width: "24"
                }
              }),
              _vm._v(" "),
              _c("b-popover", {
                attrs: {
                  target: "badge-inconvenient-pet",
                  placement: "bottom",
                  triggers: "hover",
                  title: _vm.$t("message.professional.inconvenient_pet"),
                  content: _vm.getPetTypes()
                }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73eddab5", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73eddab5","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/professional/components/CleanerBadges.vue
// module id = 1726
// module chunks = 0